import { Factory } from 'rosie';

Factory.define('UserResetPassword').attr('name', 'USER_RESET_PASSWORD');

Factory.define('UserResetPasswordWithDefaults').extend('UserResetPassword');



// WEBPACK FOOTER //
// ./factories/location/user_reset_password.js